import resolve from 'ioc/resolve'
import $session from 'servicestack/session'

const yotPOConfig = {
    
    hideYotPo: true,
    appKey: '',
    domain: '',
    url: '',
    imageUrl: ''
    
} 

export default yotPOConfig;